module.exports = __webpack_public_path__ + "img/sticky.24fc4e8b.png";